export default __webpack_public_path__ + "static/media/C970.cc84e4ce.webp";